import React from 'react';
import type { CSSProperties } from 'react';

export interface IIconProps {
    className?: string;
    style?: CSSProperties;
}

function IconDot(props: IIconProps): JSX.Element {
    return (
        <svg
            style={props.style}
            className={`${props.className ?? ''} svg-inline--fa fa-circle-minus`}
            aria-hidden="true"
            focusable="false"
            data-icon="circle"
            role="img"
            xmlns="http://www.w3.org/2000/svg"
            viewBox="0 0 100 100"
        >
            <circle fill="currentColor" cx="50" cy="50" r="50" />
        </svg>
    );
}

export default IconDot;
